import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/book-now.png")